var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAreaMaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.145 512.145",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512.085 128.069c-.133-35.346-28.894-63.892-64.24-63.759-25.145.094-47.905 14.904-58.176 37.855l-54.64-9.136-5.344 31.568 54.912 9.168a64 64 0 0 0 39.488 53.504l-15.584 117.552c-32.099 3.773-56.321 30.928-56.416 63.248v.24l-184.464 48.64a63.697 63.697 0 0 0-47.328-32L87.621 123.461a64.161 64.161 0 0 0 34.864-33.488l49.456 8.256 5.264-31.552-49.696-8.304C124.488 23.245 93.561-2.783 58.433.239 23.305 3.26-2.723 34.186.299 69.314c2.577 29.962 25.715 54.062 55.546 57.859l32.704 261.44c-32.869 12.999-48.978 50.182-35.979 83.051 12.999 32.869 50.182 48.978 83.051 35.979 24.441-9.666 40.488-33.291 40.464-59.574v-.24l184.464-48.64c17.182 30.788 56.069 41.818 86.857 24.637 30.788-17.182 41.818-56.069 24.637-86.857a63.843 63.843 0 0 0-31.878-28.1l15.584-117.552c32.067-3.81 56.246-30.955 56.336-63.248zm-448-32c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.327 32-32 32zm48 384c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32s32 14.327 32 32c0 17.673-14.327 32-32 32zm336-112c0 17.673-14.327 32-32 32-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32zm-32-240c0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32s-14.327 32-32 32c-17.673 0-32-14.327-32-32z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.905 82.495 31.565 5.268-5.268 31.564-31.564-5.267zM208.688 71.95l31.561 5.274-5.273 31.561-31.562-5.273z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaMaster);
export default __webpack_public_path__ + "static/media/area-master.5725c3d7b44746bb12d185792503b274.svg";
export { ForwardRef as ReactComponent };